import { StatsContexterService } from 'pf-frontend-common/src/service/stats-contexter/service';

import { configGetAbTests } from 'common/helper/config/get-ab-tests';
import { preactMarkup } from 'common/helper/preact/markup';
import { MyAccountPopupViewFactory } from 'common/module/my-account/popup/view.factory';
import { MyAccountView } from 'common/module/my-account/view';
import { myNotesGetIsAvailable } from 'common/module/my-notes/get-is-available';
import { PreactView } from 'common/module/preact/view';
import { MyAccountStatechartService } from 'common/service/my-account-statechart/service';
import { MyAccountStoreService } from 'common/service/my-account-store/service';
import { MyNotesService } from 'common/service/my-notes/service';
import { PropertyContactedStoreService } from 'common/service/property-contacted-store/service';
import { PropertySavedStoreService } from 'common/service/property-saved-store/service';
import { PropertyStoreService } from 'common/service/property-store/service';
import { SaveSearchStoreService } from 'common/service/save-search-store/service';
import { StatsService } from 'common/service/stats/service';
import { StatsTealiumProviderService } from 'common/service/stats-tealium-provider/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';
import { EmailAlertUnsubscribeViewFactory } from 'desktop/module/email-alert/unsubscribe/view.factory';
import { MyAccountMenuViewFactory } from 'desktop/module/my-account/menu/view.factory';
import { MyAccountPropertyListTemplate } from 'desktop/module/my-account/property-list/template';
import { MyAccountViewStrategyFactory } from 'desktop/module/my-account/view/strategy.factory';
import { PropertyListViewStoreFactory } from 'desktop/module/property/list/view-store.factory';
import { SaveSearchListComponent } from 'desktop/module/save-search/list/component';

export function MyAccountViewFactory(): MyAccountView {
  const myAccountView = new MyAccountView(
    new PreactView(MyAccountPropertyListTemplate, PropertyListViewStoreFactory()),
    PropertySavedStoreService(),
    PropertyContactedStoreService(),
    MyAccountStatechartService(),
    StatsService(),
    MyAccountPopupViewFactory(),
    MyAccountMenuViewFactory(),
    StatsContexterService(),
    PropertyStoreService(),
    UserAuthenticationService(),
    MyAccountStoreService(),
    MyNotesService(),
    SaveSearchStoreService(),
    configGetAbTests(),
    myNotesGetIsAvailable(),
    preactMarkup,
    {
      SaveSearchListComponent,
    },
    EmailAlertUnsubscribeViewFactory(),
    StatsTealiumProviderService()
  );

  // Set strategy
  myAccountView.setStrategy(MyAccountViewStrategyFactory());
  return myAccountView;
}
